import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { ToastService } from '../toast.service';
import * as XLSX from 'xlsx';
import { ExcelService } from '../excel.service';
import { Platform } from '@angular/cdk/platform';
import { MatTableDataSource } from '@angular/material/table';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-manage-promotions',
  templateUrl: './manage-promotions.component.html',
  styleUrls: ['./manage-promotions.component.scss'],
})
export class ManagePromotionsComponent {
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  } 
  items:any=[];
  loader:boolean=true;
  search:any=[];
  editId;
   cardView;
  promoCategoryObj :any ;
  promoCategoryObjName;
  promoTypeObj : any;
  promotionTypeId;
  category;
  displayedColumns = ['name','code','category','type','discountpercentage','fixedamount','delete'];
  dataSource: any; 
  excelData: any = [];
  constructor(public service:ApiService, 
              public handler:HandlerService,
              public router:Router,
              public platform:Platform,
              private excelService: ExcelService,
              public auth:AuthService) { }

  ionViewWillEnter() {
 
    if (this.platform.ANDROID || this.platform.IOS) {
      this.cardView = 'true';
    }
    else{
      if(localStorage.getItem('config')){
        var con = JSON.parse(localStorage.getItem('config'));
        let y = con.find(res => res.shortCdConst == "DFLTCARDLYT");
        if(y){
          this.cardView=y.userValue;
        }
        else{
          this.cardView = 'true';
        }
       
      }
    }
    this.getCategory();
     
  }


  getPromotions(){
    this.service.getAllPromotion().subscribe(res=>{
      if(res){
        this.items = res;
        this.items.map(dat=>{
          this.category.map(dat1 => {
            if (dat1.id == dat.purchaseCategoryId) {
              Object.assign(dat, { cateName: dat1.name })
            }
        })
          })
       
        
        this.service.getAllCategory().subscribe((res:any)=>{
          this.promoCategoryObj = res;
        })
        this.service.getAllType().subscribe((res:any)=>{
          this.promoTypeObj = res;
        })
        if(this.promoCategoryObj&&this.promoCategoryObj.length>0){
        this.promoCategoryObj.map(dat=>{
          if(dat.id==this.items.promotionType){
            this.promoCategoryObjName = dat.name;
          }
        })
      }
      this.loader = false;
        this.dataSource = new MatTableDataSource(this.items);
      }else{
        this.loader = false;
      this.items=[];
      }
    
    },err=>{
      this.loader = false;
      this.handler.err(err)
    })
  }

  getCategory(){
    this.loader=true;
    this.service.getOrgCategory().subscribe((res:any)=>{
      this.category=res;
      this.getPromotions();
     })
  }
  edit(id){
    this.router.navigate(['/edit-promotions',id]);
  }
  deletePromotion(id){
    this.loader=true;
    this.service.deletePromotion(id).subscribe(res=>{
     this.ionViewWillEnter();
     this.loader=false;
      this.handler.res("Deleted successfully")
      this.router.navigate(['/manage-promotions'])
    
     },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  }

  promoCatergoryName(id){
    if(this.promoCategoryObj && this.promoCategoryObj.length>0){
    let promocategory=this.promoCategoryObj.find(res=>{return res.id==id})
    if(promocategory)
    return promocategory.name;
  }
}
promoTypeName(id){
  if(this.promoTypeObj && this.promoTypeObj.length>0){
  let promotype=this.promoTypeObj.find(res=>{return res.id==id})
  if(promotype)
  return promotype.name;
}
}
  
  viewChange(id) {
    if (id == 1) { this.cardView = 'true'; }
    else {this.cardView = 'false'; }
  }
  exportAsXLSX(): void {
    this.items.map(res => {
      this.excelData.push({
        Name: res.name, Code: res.code, PurchaseCategory: res.purchaseCategoryId, Discount:res.discountPercentage,FixedAmount:res.fixedAmount
      })
    })
    this.excelService.exportAsExcelFile(this.excelData, 'Promotions');
  }
  refreshData(event){
    this.loader = true; 
    this.ionViewWillEnter();
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }
  ionViewWillLeave(){
    this.search = "";
  }
  clear(){
    this.search="";
  }

}

